<template>
  <div class="gfr-menu-view">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
